import React from 'react';
import { Box, Button } from '@wix/design-system';
import { Title as PackagePickerTitle } from '@wix/package-picker-components';
import { useTranslation } from 'react-i18next';
import s from './Title.scss';
import { BackButton } from 'components/BackButton/AdvancedPlans/BackButton';
import { RootStore, withInjectedRootStore } from '../../../providers';
import { useAppTitles } from 'components/AppTitle/useAppTitles';
import { ShowCaseFeatures } from '../AccountLevelFeatures/ShowCaseFeatures';
import { Experiments } from 'enums';

interface TitleProps {
  showBackButton: boolean;
  onBack(): void;
  currentStep: number;
  isSecondStepDisabled: boolean;
  rootStore: RootStore;
}

export const TitleComp: React.FC<TitleProps> = ({
  showBackButton,
  onBack,
  currentStep,
  isSecondStepDisabled,
  rootStore,
}) => {
  const { t } = useTranslation();
  const { appTitle } = useAppTitles(rootStore.appStore);
  const {
    isAnonymous,
    getSignInRedirectionLink,
    appContext: { biLogger },
    experiments,
  } = rootStore.appStore;
  const isNewStudioAnonymousContentEnabled =
    experiments[Experiments.NewStudioAnonymousContent] === 'true';

  const handleAnonymousCtaClick = () => {
    const targetUrl = getSignInRedirectionLink();
    biLogger.logAnonymousCtaClick({
      targetUrl,
      ctaName: 'studio-anonymous-top-cta',
    });
    window.open(targetUrl, '_self');
  };

  return (
    <Box direction='vertical' align='center'>
      <PackagePickerTitle
        className={s.titleContainer}
        title={t(appTitle)}
        size='extraLarge'
        paddingTop='30px'
        gap='18px'
      >
        <Box direction='vertical'>
          <Box
            direction='horizontal'
            paddingBottom={isAnonymous ? '0' : '42px'}
          >
            {showBackButton && (
              <BackButton
                className={s.backButton}
                handleOnBackButtonClick={onBack}
                currentStep={currentStep}
                isSecondStepDisabled={isSecondStepDisabled}
              />
            )}
            <ShowCaseFeatures />
          </Box>
          {isAnonymous && (
            <Box margin='SP5 auto SP3 auto'>
              <Button
                skin='premium'
                onClick={handleAnonymousCtaClick}
                className={s.wixStudioCtaColor}
              >
                {isNewStudioAnonymousContentEnabled
                  ? t('studio_package_picker.anon.CTA')
                  : t('studio_package_picker.anon.main_CTA')}
              </Button>
            </Box>
          )}
        </Box>
      </PackagePickerTitle>
    </Box>
  );
};

export const Title = withInjectedRootStore(TitleComp);
